module.exports = __webpack_public_path__ + "img/1-2.104daa55.png";